/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React, {
  useEffect, useCallback, useState, useRef, useMemo,
} from 'react';
import {
  Select, Space, Card, Spin, DatePicker, Button,
} from 'antd';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import {
  ResponsiveContainer,
} from 'recharts';
import { useTranslation } from 'react-i18next';

import CenteredContent from '@common/components/ui/CenteredContent';
import withAuth from '@common/hocs/withAuth';
import useConsultGraph from './useConsultGraph';
import styles from './ConsultGraph.module.less';

const { Option, OptGroup } = Select;
const { RangePicker } = DatePicker;

function ConsultGraph({
  deviceFieldPred, datePickerPred, defaultGranularityPred, variableFieldPred,
  modePickerFormatPred, modePickerPred
}) {

  const { t } = useTranslation();
  const {
    loading,
    granularity, granularityNew,defaultGranularity, setDefaultGranularity,
    deviceType, deviceField, setDeviceField, variableField, setVariableField, optionVariableField,
    datePicker, modePicker, modePickerFormat, changeDate, setDatePicker,changeModePicker,
    setModePicker,setModePickerFormat,
    optionsGraph, seriesGraph,
  } = useConsultGraph();

  useEffect(() => {
    setDeviceField(deviceFieldPred);
  }, [deviceFieldPred]);

  useEffect(() => {
    setDatePicker(datePickerPred);
  }, [datePickerPred]);

  useEffect(() => {
    setDefaultGranularity(defaultGranularityPred);
  }, [defaultGranularityPred]);
  
  useEffect(() => {
    setVariableField(variableFieldPred);
  }, [variableFieldPred]);

  useEffect(() => {
    setModePickerFormat(modePickerFormatPred);
  }, [modePickerFormatPred]);

  useEffect(() => {
     setModePicker(modePickerPred);
  }, [modePickerPred]);

  return (
    <Card style={{
      marginTop: 40, width: '100%', boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)', height: 900,
    }}
    >
      <Space className={styles.header}>
        <div className={styles.attribute_input}>
          <Select className={styles.select_attribute} value={deviceField} onChange={setDeviceField} disabled={loading} dropdownStyle={{ minWidth: '25%' }}>
            {
              deviceType.length
                ? deviceType.map((item, index) => (
                  <Option key={`${item.id}_${index}`} value={item.id}>{item.name}</Option>
                ))
                : null
            }
          </Select>

        </div>
        <div className={styles.datepicker_input}>
          <div className={styles.header_datepicker}>

            {/*<Button className={styles.btnPre} onClick={() => changeDate(-1)} disabled={loading}>{'<'}</Button>*/}

            {/*<DatePicker className={styles.btnCenter} value={datePicker} format={modePickerFormat} onChange={setDatePicker} picker={modePicker} disabled={loading} />*/}

            <RangePicker className={styles.btnCenter} value={datePicker} format={modePickerFormat} onChange={setDatePicker} picker={modePicker?modePicker:'day'} disabled={loading}/>

            {/*<Button className={styles.btnNext} onClick={() => changeDate(1)} disabled={loading}>{'>'}</Button>*/}

          </div>
        </div>
        <div className={styles.attribute_input}>
          <Select className={styles.select_attribute} value={defaultGranularity} onChange={changeModePicker} disabled={loading}>
            {granularityNew.map((dat, index) => <Option key={`${dat.value}_${index}`} value={dat.value}>{dat.name}</Option>)}
          </Select>
        </div>
      </Space>
      <Space className={styles.header2}>
        <div style={{ width: '100%' }}>
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%' }}
            placeholder="Seleecione"
            disabled={loading}
            options={optionVariableField}
            value={variableField}
            onChange={setVariableField}
          />
        </div>
      </Space>
      {(() => {

        if (loading) {

          return (
            <CenteredContent heightContainer="400px">
              <Spin tip={t('common.feedbacks.loading_chart')} />
            </CenteredContent>
          );

        }

        return (
          <ResponsiveContainer width="96%" height={600}>
            {
              deviceType.length
                ? (
                  <Chart
                    className="container-graph-third"
                    options={optionsGraph}
                    series={seriesGraph}
                    width="100%"
                    type="bar"
                  />
                )
                : <p style={{ color: '#39587D' }}><b>{t('common.feedbacks.variables_chart')}</b></p>
            }
          </ResponsiveContainer>
        );

      })()}
    </Card>
  );

}

ConsultGraph.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  className: PropTypes.string,
  deviceFieldPred: PropTypes.string,
  datePickerPred: PropTypes.object,
  defaultGranularityPred: PropTypes.string,
  variableFieldPred: PropTypes.array,
};

ConsultGraph.defaultProps = {
  className: null,
  deviceFieldPred: null,
  datePickerPred: null,
  defaultGranularityPred: null,
  variableFieldPred: null,
};

export default withAuth(ConsultGraph);
